import { render, staticRenderFns } from "./job-activities.vue?vue&type=template&id=d15294a2&scoped=true&"
import script from "./job-activities.vue?vue&type=script&lang=js&"
export * from "./job-activities.vue?vue&type=script&lang=js&"
import style0 from "./job-activities.vue?vue&type=style&index=0&id=d15294a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d15294a2",
  null
  
)

export default component.exports